// extracted by mini-css-extract-plugin
export default {"mileageTitle":"VrmInputMileage__mileageTitle-ukAk","component":"VrmInputMileage__component-SU1j","textCenter":"VrmInputMileage__textCenter-cyxJ"};